module.exports = [
  -52.2724990845, -3.20076746581E-15,
  52.2724990845, -4.56980706076E-06

]
